// Chargeurs des tableaux de bord (code découpé par rôle). Partagés par App, le tableau de bord combiné et la
// connexion : celle-ci précharge le tableau de bord avant de quitter la fenêtre, pour ne pas laisser l'accueil
// affiché pendant le téléchargement (React Router garde l'ancienne page tant que la nouvelle n'est pas prête).
import { getDashboardRoute, normalizeRole } from '../utils/dashboardRoute';
import { unifiedRolesOf } from './Unified/unifiedMenu';

export const DASHBOARD_LOADERS = {
  tenant: () => import('./Tenant'),
  admin: () => import('./Administrative'),
  accounting: () => import('./Accounting'),
  salesmanager: () => import('./SalesManager'),
  technician: () => import('./Technician'),
  landlord: () => import('./Landlord'),
  superadmin: () => import('./SuperAdminDashboard'),
  agency_director: () => import('./AgencyDirector'),
  unified: () => import('./Unified/UnifiedDashboard')
};

/** Télécharge le code du tableau de bord de ce compte (sans l'afficher). Ne lève jamais d'erreur. */
export function preloadDashboard(user) {
  if (!user) return Promise.resolve();
  const role = normalizeRole(user.role);
  const loads = [];
  if (unifiedRolesOf(user).length > 1) {
    loads.push(DASHBOARD_LOADERS.unified());
    // Écran affiché par défaut dans le tableau de bord combiné : celui de la fonction principale
    if (DASHBOARD_LOADERS[role]) loads.push(DASHBOARD_LOADERS[role]());
  } else {
    const loader = DASHBOARD_LOADERS[role] || DASHBOARD_LOADERS.tenant;
    loads.push(loader());
  }
  return Promise.all(loads).then(() => undefined, () => undefined);
}

export { getDashboardRoute };
